import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/store';
import { bonusSettlementsSupplierOverviewDetailsSelector } from '../../supplier-overview/store/bonus-settlements-supplier-overview-selector';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementsCustomerOverviewSelector = createSelector(
    bonusSettlementsState,
    state => state.customerOverview.bonusSettlementsCustomerOverview
);
export const bonusSettlementsCustomerOverviewRequestingSelector = createSelector(
    bonusSettlementsState,
    state => state.customerOverview.requesting
);
export const bonusSettlementsCustomerOverviewDetailsSelector = createSelector(
    bonusSettlementsState,
    bonusSettlementsSupplierOverviewDetailsSelector,
    (state, sup) => {
        return {
            ...state.customerOverview.details,
            type: sup?.type,
        };
    }
);
